
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certifications",
      function () {
        return require("private-next-pages/certifications/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certifications"])
      });
    }
  